(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var toggle = document.getElementById('mobile-menu-toggle');
  var menu = document.getElementById('mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  var closeBtn = document.getElementById('mobile-menu-close');

  function openMenu() {
    menu.classList.add('is-open');
    document.documentElement.classList.add('is-mobile-menu-open');
    document.body.classList.add('is-mobile-menu-open');
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    document.documentElement.classList.remove('is-mobile-menu-open');
    document.body.classList.remove('is-mobile-menu-open');
    var mp = document.getElementById('mobile-search-results');
    if (mp) {
      mp.hidden = true;
      mp.innerHTML = '';
    }
  }

  if (toggle) toggle.addEventListener('click', openMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  var searchEl = document.getElementById('header-search');
  if (searchEl) {
    var searchInput = searchEl.querySelector('.header__search-input');
    var searchForm = searchEl.querySelector('.header__search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        var q = searchInput ? searchInput.value.trim() : '';
        if (!q) return;
        e.preventDefault();
        var path = window.location.pathname;
        var base =
          path.indexOf('/collections/') === 0
            ? path.split('?')[0]
            : '/collections/all';
        window.location.href = base + '?pn=' + encodeURIComponent(q);
      });
    }

    var predictiveUrl = searchEl.dataset.predictiveUrl || '/search/suggest';

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments,
          ctx = this;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    }

    function setupPredictive(input, panel) {
      if (!input || !panel) return;
      var aborter = null;

      function hide() {
        panel.hidden = true;
        panel.innerHTML = '';
      }

      var run = debounce(function (q) {
        if (!q || q.length < 2) {
          hide();
          return;
        }
        if (aborter) {
          try {
            aborter.abort();
          } catch (_) {}
        }
        aborter =
          typeof AbortController !== 'undefined' ? new AbortController() : null;
        var url =
          predictiveUrl +
          '?q=' +
          encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        var opts = {};
        if (aborter) opts.signal = aborter.signal;
        fetch(url, opts)
          .then(function (r) {
            return r.ok ? r.text() : null;
          })
          .then(function (html) {
            if (html == null) return;
            if (q !== input.value.trim()) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var wrapper = doc.querySelector('.shopify-section');
            panel.innerHTML = wrapper ? wrapper.innerHTML : html;
            panel.hidden = false;
          })
          .catch(function () {});
      }, 220);

      input.addEventListener('input', function () {
        run(input.value.trim());
      });
      input.addEventListener('focus', function () {
        if (input.value.trim() && panel.innerHTML) panel.hidden = false;
      });
      document.addEventListener('click', function (e) {
        if (!panel.contains(e.target) && e.target !== input)
          panel.hidden = true;
      });
    }

    setupPredictive(
      searchInput,
      document.getElementById('header-search-results'),
    );
    setupPredictive(
      document.querySelector('.mobile-menu__search input'),
      document.getElementById('mobile-search-results'),
    );
  }

  var langEl = document.getElementById('header-lang');
  if (langEl) {
    var langBtn = langEl.querySelector('.header__lang-current');
    if (langBtn) {
      langBtn.addEventListener('click', function () {
        var isOpen = langEl.classList.toggle('is-open');
        langBtn.setAttribute('aria-expanded', isOpen);
      });
    }
    document.addEventListener('click', function (e) {
      if (!langEl.contains(e.target)) {
        langEl.classList.remove('is-open');
        if (langBtn) langBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
